import {
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  inject,
  computed,
} from '@angular/core';
import { EEAGapPWCSurfaceWaterV3Coldef } from './eea-gap-surfacewater-pwc3.coldef';
import { EEAGapPWCSurfaceWaterV2Coldef } from './eea-gap-surfacewater-pwc2.coldef';

import { Project } from 'src/app/shared/models/project';
import { Constants } from 'src/app/shared/utils/constants';
import { Catalog } from 'src/app/shared/models/echo/catalog';
import {
  ColDef,
  RowSelectedEvent,
  SelectionChangedEvent,
  RowGroupOpenedEvent,
} from 'ag-grid-community';
import { GridComponent } from 'src/app/shared/components/grid/grid.component';
import { CropEvents } from 'src/app/shared/models/pwc/crop-events';
import { firstValueFrom, take } from 'rxjs';

import {
  ApplicationScheme,
  ApplicationSchemeCropState,
  ApplicationSchemeXApplication,
} from 'src/app/shared/models/application-scheme';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GridLogicService } from 'src/app/shared/components/grid/grid.logic.service';
import { CropInterceptionStep1And2 } from 'src/app/shared/models/crop-interception';
import { CropListMatching } from 'src/app/shared/models/crop-list-matching';
import { TabMenuLogicService } from 'src/app/shared/services/tab-menu.logic.service';
import { EEAGapLogicService } from '../eea-gap.logic.service';
import { EEAGapApiService } from '../eea-gap.api.service';
import { EEAGAPMenuLogicService } from '../eea-gap/eea-gap-menu.logic.service';
import { GapApplicationSchemeLogicService } from 'src/app/shared/services/gap-application-scheme.logic.service';
import { SaveStructure, TransactionType } from 'src/app/shared/models/transaction-type';
import { EeaGapSurfacewaterPwcScenariosLogicService } from './eea-gap-surfacewater-pwc-scenarios/eea-gap-surfacewater-pwc-scenarios.logic.service';
import { SelectedScenariosByRow } from 'src/app/shared/models/pwc/scenarios.interface';
import { DriftTypes } from 'src/app/shared/models/pwc/drift-types';
import { ApplicationMethods } from 'src/app/shared/models/pwc/application-methods';
import { DataSetApiService } from 'src/app/shared/services/echo/data-set.api.service';
import { EEAGapSurfaceWaterPWCLogicService } from './eea-gap-surfacewater-pwc-logic.service';
import { isPwcV2Project } from 'src/app/shared/utils/pwc-version.utils';
import { Utils } from 'src/app/shared/utils/utils';
import { SelectedProjectApiService } from 'src/app/shared/components/selected-project/selected-project.api.service';
import { EndpointDatasetLogicService } from 'src/app/shared/components/endpoint-dataset/endpoint-dataset.logic.service';

@Component({
  selector: 'app-eea-gap-surfacewater-pwc',
  templateUrl: './eea-gap-surfacewater-pwc.component.html',
  styleUrls: ['./eea-gap-surfacewater-pwc.component.css'],
})
export class EEAGapSurfacewaterPwcComponent implements OnInit, OnChanges {
  @ViewChild('grid') grid!: GridComponent;

  @Input() menuService!: TabMenuLogicService;
  @Input() isProjectOwnershipValid: boolean = false;
  @Input() useModels!: boolean;
  @Input() subTabMenuService!: TabMenuLogicService;
  @Input() selectedProject?: Project;

  @Output() public isValid = new EventEmitter<boolean>();

  public detailsColumnDef: any = [];
  public defaultColDef: ColDef = { flex: 2 };
  public selectedRow?: ApplicationScheme;
  public showScenarios = computed(() => this.scenariosLogicService.visible());
  private dataSetApiService = inject(DataSetApiService);
  private pwcLogicService = inject(EEAGapSurfaceWaterPWCLogicService);
  columnsDef: any;
  saveRef?: string;
  rowData: any;
  compartmentList!: any[];
  datafieldOptions!: any[];
  geographies!: Catalog[];
  cropInterceptionsStep1And2!: CropInterceptionStep1And2[];
  applicationSchemeCropsStates: ApplicationSchemeCropState[] = [];
  missingDataRows: any[] = [];
  cropListMatchings!: CropListMatching[];
  numbersOfApplication!: any[];
  cropEvents: CropEvents[] = [];
  drifTypes: DriftTypes[] = [];
  applicationMethods: ApplicationMethods[] = [];
  isMasterDetail: boolean = true;
  isloading: boolean = false;
  compartment: string = Constants.COMPARTMENTS.SURFACE_WATER;
  show: boolean = true;
  pwcFlag: boolean = true;
  get isPwcV2(): boolean {
    return !!this.selectedProject && isPwcV2Project(this.selectedProject);
  }
  selectedGeography: string | undefined = '';
  destroyRef = inject(DestroyRef);
  isRuning: boolean = true;
  compartmentPk!: number;
  childrens: any;
  highlightRow: boolean = false;
  qcFinish: boolean = false;
  columnSizeMode: string = 'fit';
  autoGroupColDef: any = {
    headerValueGetter: (params: { colDef: { headerName: any } }) =>
      `${params.colDef.headerName}`,
    cellRendererParams: {
      suppressCount: true,
      checkbox: true,
    },
  };

  constructor(
    private gapLogicSWService: EEAGapLogicService,
    private gapLogicApi: EEAGapApiService,
    private gridService: GridLogicService,
    private EEAGAPMenuLogicService: EEAGAPMenuLogicService,
    private gapApplicationSchemeLogicService: GapApplicationSchemeLogicService,
    private eEAGapPWCSurfaceWaterV3Coldef: EEAGapPWCSurfaceWaterV3Coldef,
    private eEAGapPWCSurfaceWaterV2Coldef: EEAGapPWCSurfaceWaterV2Coldef,
    private readonly selectedProjectAPIService: SelectedProjectApiService,
    public readonly logicService: EndpointDatasetLogicService,
  ) { }

  private get activeColdef(): EEAGapPWCSurfaceWaterV3Coldef | EEAGapPWCSurfaceWaterV2Coldef {
    return this.isPwcV2 ? this.eEAGapPWCSurfaceWaterV2Coldef : this.eEAGapPWCSurfaceWaterV3Coldef;
  }

  private scenariosLogicService = inject(
    EeaGapSurfacewaterPwcScenariosLogicService
  );
  private pwcLogicScenarios = inject(
    EeaGapSurfacewaterPwcScenariosLogicService
  );
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedProject'].currentValue.projectPk) {
      this.initSubscribes();
      this.IniValues(changes);
    }
  }
  async ngOnInit(): Promise<void> {
    this.detailsColumnDef = this.isPwcV2
      ? EEAGapPWCSurfaceWaterV2Coldef.getPWCDetailsColumnsDefination(this, this.isProjectOwnershipValid, this.selectedProject)
      : EEAGapPWCSurfaceWaterV3Coldef.getPWCDetailsColumnsDefination(this, this.isProjectOwnershipValid);
    this.initSubscribes();
    this.isloading = true;
    await this.scenariosLogicService.getCropsXRegion(this.isPwcV2 ? Constants.GEOGRAPHYS.BRAZIL : Constants.GEOGRAPHYS.USA);
  }

  initSubscribes() {
    this.menuService.activeIndexChanged
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.saveRef = this.menuService.saveRef;
        this.saveData(this.grid?.transactionList);
        this.menuService.setSuccess(true);
      });

    this.subTabMenuService.activeIndexChanged
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.saveRef = this.subTabMenuService.saveRef;
        this.saveData(this.grid?.transactionList);
        this.subTabMenuService.setSuccess(true);
      });
  }

  dropDownSelectionChanged(event: any) {
    if (Constants.GAP_PWC_DETAIL_FIELDS.includes(event.field))
      event.params.data.isChild = true;

    if (event.field === Constants.FIELD_NAMES.DATE_TYPE) {
      event.params.data[event.field] = event.value;
      event.row[event.field] = event.value;
      let parentRowNode = this.grid?.gridApi.getRowNode(event.params?.node.id);
      if (parentRowNode?.data?.children) {
        let children = parentRowNode?.data?.children;
        children.map((x: any) => {
          x.dateType = event.value;
        });
        this.grid?.gridApi.refreshCells({ force: true });
      }

      var node1 = event.params.api.getDisplayedRowAtIndex(
        event?.params?.node?.id
      );
      const childrens = this.detailsColumnDef?.flatMap(
        (node: { children: any }) => node.children
      );
      let appDate = childrens?.find(
        (x: any) => x.field === 'application_date'
      ) as any;
      let Days = childrens?.find(
        (x: { headerName: string }) =>
          x.headerName === Constants.COLUMN_HEADER_NAMES.DAYS_SINCE
      ) as any;
      if (event.value === Constants.DATE_TYPE_VALUES.RELATIVE) {
        this.addApplicationRowsByApplicationNumber(event, 1);
        if (appDate) {
          appDate.editable = false;
          Days.editable = true;
          if (!this.isPwcV2) {
            this.setApplicationDateHeader(event.row);
          }
        }

      }
      if (event.value === Constants.DATE_TYPE_VALUES.ABSOLUTE) {

        event.row.cropEvent = null;
        appDate.editable = true;
        Days.editable = false;
        if (appDate) {
          if (!this.isPwcV2) {
            this.setApplicationDateHeader(event.row);
          }
        }
      }
      if (this.isPwcV2) {
        this.grid?.detailGridApi?.refreshHeader?.();
      }
      this.grid?.gridApi.refreshCells({ force: true });
      this.grid?.gridApi.redrawRows();
    }
    if (event.field === 'numberOfApplications') {
      event.params.data[event.field] = event.value;
      this.addApplicationRowsByApplicationNumber(event, event.value);
    }
    this.grid?.detailGridApi?.redrawRows();
  }

  addApplicationRowsByApplicationNumber(event: any, numberApplication: number) {
    let row = event.row;
    let childrenValues: any[] = this.getApplicationRows(
      numberApplication,
      event.row.children,
      event
    );
    event.row.children = [];
    event.row.children = childrenValues;
    this.grid.gridApi.redrawRows();
  }

  private getApplicationRows(
    applicationNumber: number,
    existingChildren: ApplicationSchemeXApplication[],
    event: any
  ): ApplicationSchemeXApplication[] {
    const adjustedChildren = this.adjustChildren(
      existingChildren,
      applicationNumber
    );
    let applicationNumberToCreate: number =
      adjustedChildren !== undefined &&
        applicationNumber > adjustedChildren.length
        ? applicationNumber - adjustedChildren.length
        : 0;
    let newChildren: ApplicationSchemeXApplication[] = [];
    if (adjustedChildren?.length > 0) {
      newChildren = this.createNewChildren(
        applicationNumberToCreate,
        adjustedChildren.length,
        event
      );
      return [...adjustedChildren, ...newChildren];
    }

    if (existingChildren === undefined || existingChildren.length === 0) {
      return (newChildren = this.newChildrenToCreate(applicationNumber, event));
    }
    return newChildren;
  }
  private createNewChildren(
    numberOfNewChildren: number,
    lastItemIndex: number,
    data: any
  ): ApplicationSchemeXApplication[] {
    return Array.from({ length: numberOfNewChildren }, (_, index) =>
      this.createApplicationSchemeXApplication(lastItemIndex + index + 1, data)
    );
  }

  private adjustChildren(
    children: ApplicationSchemeXApplication[],
    applicationNumber: number
  ): ApplicationSchemeXApplication[] {
    if (children !== undefined && children.length > applicationNumber) {
      return children.slice(0, applicationNumber);
    }
    return children;
  }

  private newChildrenToCreate(
    applicationNumber: number,
    event: any
  ): ApplicationSchemeXApplication[] {
    let childrenValues: ApplicationSchemeXApplication[] = [];
    for (let index = 0; index < applicationNumber; index++) {
      const newChildren: ApplicationSchemeXApplication = {
        application_scheme_x_application_pk: 0,
        application_date: undefined,
        application_method: 0,
        application_number: index + 1,
        application_scheme_pk: 0,
        crop_interception: 0,
        day: undefined,
        days_since: 0,
        depth: undefined,
        drift: 0,
        earliest_bbch: '0',
        reservoir_efficiency: 0,
        min_application_interval: 0,
        month: 0,
        t_band_split: undefined,
        period: 1,
        lag: 0,
        year: 0,
        dateType: event.row.dateType,
        specifyYears: event.row.specifyYears,
      };
      childrenValues.push(newChildren);
    }
    return childrenValues;
  }
  private createApplicationSchemeXApplication(
    applicationNumber: number,
    data: any
  ): ApplicationSchemeXApplication {
    return {
      application_scheme_x_application_pk: 0,
      application_date: undefined,
      application_method: 0,
      application_number: applicationNumber,
      application_scheme_pk: 0,
      crop_interception: 0,
      day: undefined,
      days_since: 0,
      depth: undefined,
      drift: 0,
      earliest_bbch: '0',
      reservoir_efficiency: 0,
      min_application_interval: 0,
      month: 0,
      t_band_split: undefined,
      period: 1,
      lag: 0,
      year: 0,
      dateType: data.row.dateType,
      specifyYears: data.row.specifyYears,
    };
  }

  getApplicationsByApplication(data: any): ApplicationSchemeXApplication[] {
    let childrenValues: ApplicationSchemeXApplication[] = [];
    if (data.length > 0) {
      const childrens = data.map((x: ApplicationSchemeXApplication) => {
        return {
          application_scheme_x_application_pk:
            x.application_scheme_x_application_pk,
          application_date: x.application_date,
          application_method: x.application_method,
          application_number: x.application_number,
          application_scheme_pk: x.application_scheme_pk,
          crop_interception: x.crop_interception,
          day: x.day,
          days_since: x.days_since,
          depth: x.depth,
          drift: x.drift,
          earliest_bbch: x.earliest_bbch,
          reservoir_efficiency: x.reservoir_efficiency,
          reservoir_drift: x.reservoir_drift,
          pond_efficiency: x.pond_efficiency,
          pond_drift: x.pond_drift,
          custom_efficiency: x.custom_efficiency,
          custom_drift: x.custom_drift,
          min_application_interval: x.min_application_interval,
          month: x.month,
          t_band_split: x.t_band_split,
          period: x.period,
          lag: x.lag,
          year: x.year,
          dateType: x.dateType,
        };
      });
    }
    return childrenValues;
  }
  cropEvent(event: any) {

    const childrens = this.detailsColumnDef?.flatMap(
      (node: { children: any }) => node.children
    );
    let daySince = childrens?.find(
      (x: { headerName: string }) =>
        x.headerName === Constants.COLUMN_HEADER_NAMES.DAYS_SINCE
    ) as any;
    let crop = this.columnsDef?.find(
      (x: { headerName: string }) =>
        x.headerName === Constants.COLUMN_HEADER_NAMES.CROP_EVENT
    ) as any;
    let appDate = childrens?.find(
      (x: any) => x.field === 'application_date'
    ) as any;
    var node1 = event.params.api.getDisplayedRowAtIndex(event?.id)!;
    if (
      event.dateType === Constants.FIELD_NAMES.DATE_TYPE ||
      (event.field === Constants.FIELD_NAMES.DATE_TYPE &&
        event.value === Constants.DATE_TYPE_VALUES.RELATIVE)
    ) {
      if (crop && appDate) {
        this.grid?.gridColumnApi.setColumnVisible(crop?.field, true);
        appDate.hide = true;
        daySince.hide = false;
        this.isExpanded(node1);
      }
    } else {
      appDate.hide = false;
      daySince.hide = true;

      this.grid?.gridColumnApi.setColumnVisible(crop?.field, false);
      this.isExpanded(node1);
    }
    this.grid?.gridApi.refreshCells();
    this.grid.gridApi.redrawRows();
  }
  isExpanded(node: any) {
    if (node?.expanded) {
      this.grid.gridApi.setRowNodeExpanded(node, false);
    } else {
      this.grid.gridApi.setRowNodeExpanded(node, true);
    }
  }

  saveData(dataTransaction: any[]) {
    if (dataTransaction === undefined) {
      this.menuService.setSuccess(true);
      this.subTabMenuService.setSuccess(true);
      return;
    }

    if (dataTransaction.length <= 0) {
      this.menuService.setSuccess(true);
      this.subTabMenuService.setSuccess(true);
      return;
    }

    if (dataTransaction.length == 0) {
      this.EEAGAPMenuLogicService.setSuccess(true);
      return;
    }

    if (!this.selectedProject) return;

    this.gapLogicSWService.setParametersToNewRowsPWC(
      dataTransaction,
      this.compartmentPk,
      false,
      this.selectedProject?.projectPk
    );
    this.gapLogicSWService.transformPWCDetailsObjectToApplicationSchemeXApp(
      dataTransaction
    );

    const transformedData: SaveStructure[] =
      this.gapLogicSWService.transformToSaveStructureObject(dataTransaction);
    if (dataTransaction.length > 0) {
      this.gapLogicApi
        .savePWC(transformedData)
        .pipe(take(1))
        .subscribe({
          next: () => {
            this.grid.afterSaveSuccess();
            this.saveRef === Constants.WIZARD_MENU_REF.Master
              ? this.menuService.setSuccess(true)
              : this.subTabMenuService.setSuccess(true);

          },
          error: (err: any) => {
            console.warn(err);
            this.saveRef === Constants.WIZARD_MENU_REF.Master
              ? this.menuService.setSuccess(false)
              : this.subTabMenuService.setSuccess(false);
          },
        });
      this.grid.transactionList = [];
    }
  }

  getColumnDefPwc(option: any) {
    return this.activeColdef.getPWCColumnsDefinition(
      option,
      this.isProjectOwnershipValid,
      this.selectedProject
    );
  }

  private refreshSelectedValuesTimeout(): void {
    setTimeout(() => {
      this.refreshSelectedValues();
    }, 75);
  }
  private refreshSelectedValues(): void {
    if (!this.grid) return;
    this.grid.refreshSelectedValues(Constants.FIELD_NAMES.USE_IN_PROJECT);
  }

  onModelOptionsChanged(models: string[]) {
    if (models.map((x: string) =>  Constants.PWC_VERSIONS.includes(x))[0]) {

      this.pwcFlag = true;
      return;
    }

    if (this.grid) {
      const geographiesToFilter = [
        Constants.CROP_GEOGRAPHIES.EUROPE_UNION,
        Constants.CROP_GEOGRAPHIES.UK,
        Constants.CROP_GEOGRAPHIES.USA,
      ];
      let selectedGeography = this.geographies
        .filter((x: Catalog) => geographiesToFilter.includes(x.name ?? ''))
        ?.find(
          (x: Catalog) =>
            this.selectedProject?.countryPk === x.key ||
            this.selectedProject?.regionPk === x.key
        )?.name;
      this.selectedGeography = selectedGeography;
      let columns: any[] = this.gapLogicSWService.getDisplayedColumnsByModel(
        models,
        selectedGeography!
      );
      let displayedColumns = this.grid?.gridColumnApi.getColumns();
      let fixedColumns = Utils.getFirstMatchBetweenTwoArrays(models, Constants.MODELS_WITH_APPDATES)
        ? ['deleteButton', 'appWindow']
        : ['deleteButton'];
      let columnsToShow: string[] = [
        ...Constants.GAP_CORE_FIELDS,
        ...new Set(columns),
        ...this.gapLogicSWService.getFixedColumns(
          displayedColumns,
          fixedColumns
        ),
      ];
      columnsToShow = this.removeColumnsByModel(models, columnsToShow);
      displayedColumns.map((column: any) => {
        this.grid?.gridColumnApi.setColumnVisible(
          column.colId,
          columnsToShow.includes(column.getColDef().field)
        );
      });
      this.grid?.gridApi.refreshCells();
    }
  }

  removeColumnsByModel(models: string[], columnsToShow: string[]) {
    return this.removeUKColumns(models, columnsToShow);
  }

  removeUKColumns(models: string[], columnsToShow: string[]) {
    return JSON.stringify(models) ===
      JSON.stringify(new Array(Constants.MODELS.UK))
      ? columnsToShow.filter((x: string) => x !== 'geographies')
      : columnsToShow;
  }

  IniValues(changes: SimpleChanges) {
    let promises = [
      this.gapLogicSWService.getCompartments(),
      this.gapLogicSWService.getStep1n2Interceptions(),
      this.gapLogicSWService.getCropListMatchings(),
      this.gapLogicSWService.getPWCCropEvents(),
      this.gapLogicSWService.getPWCApplicationMethods(),
      this.gapLogicSWService.numerOfApplications,
      this.gapLogicSWService.getPWCDriftTypes(),
    ];
    Promise.all(promises).then(async (results) => {
      this.compartmentList = results[0];
      this.cropInterceptionsStep1And2 = results[1];
      this.cropListMatchings = results[2];
      this.cropEvents = results[3].map((crop: any) => {
        return { id: crop, name: crop };
      });
      this.applicationMethods = results[4].map((x) => {
        return { id: x, name: x };
      });
      this.numbersOfApplication = results[5];
      this.drifTypes = results[6].map((x) => {
        return { id: x, name: x };
      });
      await this.getApplicationSchemesByProjectAndCompartment(
        changes['selectedProject'].currentValue.projectPk,
        this.getCompartmentPk()
      );
    });
    if (this.selectedProject?.projectPk !== undefined) {
      this.getDatasetByProjectPk(this.selectedProject.projectPk);
    }
  }
  onCellChanged(event: any) { }
  setColumnEditableAndStyle(
    columnField: string,
    editable: boolean,
    cellStyle: any
  ) {
    const childrens = this.detailsColumnDef?.flatMap(
      (node: { children: any }) => node.children
    );
    let column = childrens?.find(
      (x: { headerName: string }) => x.headerName === columnField
    ) as any;

    if (column) {
      column.editable = editable;
      column.cellStyle = cellStyle;
      this.grid.detailGridApi.refreshCells({ force: true });
      this.grid.detailGridApi.redrawRows(childrens);
    }
  }

  setApplicationMethodEditable2(event: any) {
    const childrens = this.detailsColumnDef?.flatMap(
      (node: { children: any }) => node.children
    );
    let depth = childrens?.find(
      (x: { headerName: string }) =>
        x.headerName === Constants.COLUMN_HEADER_NAMES.APPLICATION_METHOD_DEPTH
    ) as any;
    let tband = childrens?.find(
      (x: { headerName: string }) =>
        x.headerName === Constants.PWCControlsValidations.TBAND
    ) as any;

    if (event.field === Constants.COLUMN_HEADER_NAMES.APPLICATION_METHOD) {
      switch (event.value) {
        case Constants.FIELD_NAMES.APPLICATION_METHOD_DEPTH:
          tband.cellStyle = {
            'background-color': '#f0f0f0',
            'pointer-events': 'auto',
            fontWeight: 'bold',
          };
          this.setColumnEditableAndStyle(depth.headerName, true, {
            'background-color': 'none',
          });
          this.setColumnEditableAndStyle(tband.headerName, false, {
            'background-color': '#f0f0f0',
            'pointer-events': 'auto',
            fontWeight: 'bold',
          });
          break;
        case Constants.COLUMN_HEADER_NAMES.APPLICATION_METHOD_ABOVE_CROP:
          this.setColumnEditableAndStyle(depth.headerName, true, {
            'background-color': 'none',
          });
          this.setColumnEditableAndStyle(tband.headerName, false, {
            'background-color': '#f0f0f0',
            'pointer-events': 'auto',
            fontWeight: 'bold',
          });
          break;
        case Constants.COLUMN_HEADER_NAMES.APPLICATION_METHOD_BELOW_CROP:
          this.setColumnEditableAndStyle(depth.headerName, true, {
            'background-color': 'none',
          });
          this.setColumnEditableAndStyle(tband.headerName, false, {
            'background-color': '#f0f0f0',
            'pointer-events': 'auto',
            fontWeight: 'bold',
          });
          break;
      }
    }
    this.grid.detailGridApi.refreshCells({ force: true });
    this.grid.detailGridApi.redrawRows(event.row);
  }

  onCellValueChanged(event: any) { }
  getColDefFilteredBySelectedModels() {
    if (!this.selectedProject) return;
    const geographiesToFilter = [
      Constants.CROP_GEOGRAPHIES.EUROPE_UNION,
      Constants.CROP_GEOGRAPHIES.UK,
      Constants.CROP_GEOGRAPHIES.USA,
    ];
    let selectedGeography = this.geographies
      .filter((x: Catalog) => geographiesToFilter.includes(x.name ?? ''))
      ?.find(
        (x: Catalog) =>
          this.selectedProject?.countryPk === x.key ||
          this.selectedProject?.regionPk === x.key
      )?.name;
    const colDefParams = {
      applicationMethods: this.applicationMethods,
      geographySelected: selectedGeography,
      cropListMatching: this.cropListMatchings,
    };
    return this.getColumnDefPwc(colDefParams);
  }

  public async onCheckboxSelectedChanged(event: any): Promise<void> {
    if (
      event.field ==
      Constants.PWC_FIELD_NAMES.ADJUST_APPLICATION_DATES_IF_RAINING &&
      event.value == false
    ) {
      event.row.intolerableRainCm = null;
      event.row.intolerableRainWindowDays = null;
      event.row.optimumApplicationWindowDays = null;
      event.row.minimumDaysBetweenApplications = null;
    }
    if (event.field === 'specifyYears') {
      if (event.row.children) {
        event.row.children.forEach((child: any) => {
          child.specifyYears = event.value;
        });
      }
      const childrens = this.detailsColumnDef?.flatMap(
        (node: { children: any }) => node.children
      );
      const appDate = childrens?.find((x: any) => x.field === 'application_date') as any;
      if (appDate && !this.isPwcV2) {
        this.setApplicationDateHeader({
          ...event.row,
          specifyYears: event.value,
        });
      }
      this.grid?.gridApi.refreshCells({ force: true });
    }
    this.grid.gridApi.redrawRows();
  }

  onRowExpanded(event: RowGroupOpenedEvent): void {
    Utils.handleRowExpanded(event, this.grid);
    if (!event.node?.expanded) return;
    if (this.isPwcV2) {
      this.grid?.detailGridApi?.refreshHeader?.();
      return;
    }
    this.setApplicationDateHeader(event.node?.data);
  }

  getCompartmentPk() {
    this.compartmentPk = Number(
      this.compartmentList
        ?.filter(
          (x: any) => x.compartment == Constants.COMPARTMENTS.SURFACE_WATER
        )
        ?.map((x) => x.endpointCompartmentPk)
        .flat()
    );
    return this.compartmentPk;
  }

  onDelete() {
    this.gridService.removeTransaction(this.grid.transactionList);
  }

  public onSelectionChanged(event: SelectionChangedEvent) {
    if (event.source !== 'uiSelectAll' || !this.grid) return;
    this.grid.gridApi.forEachNode((node: any) => {
      this.createTransactionForSelectedRow(node);
    });
  }

  public onSelectedRow(event: RowSelectedEvent): void {
    if (!this.grid) return;
    this.createTransactionForSelectedRow(event.node);
  }
  public onBtnSelectAllClicked(): void {
    this.grid.gridApi.forEachNode((node: any) => {
      if (node.data.eraSmeSelection !== node.selected)
        node.data.eraSmeSelection = node.selected;

      node.data.eraManualSelection = true;
      this.grid.CreateTransaction(node.id, node.id, '', node.data);
    });
  }

  private createTransactionForSelectedRow(node: any): void {
    const { id, data } = node;
    data.useInProject = node.isSelected();
    this.grid.CreateTransaction(id, id, data.useInProject, data);
  }

  onDeleteDetails(event: any) {
    let deletePKs = event.detail.map(
      (x: { application_scheme_x_application_pk: any }) =>
        x.application_scheme_x_application_pk
    );
    event.parent.children = event.parent.children.filter(
      (x: { PK: any }) => !deletePKs.includes(x.PK)
    );
    let indexToRemove = event.parent.children.findIndex((x: { PK: any }) =>
      deletePKs.includes(x.PK)
    );
    event.parent.haveChanges = true;
    event.parent.children.splice(indexToRemove, 1);
    this.gridService.removeDetailTransaction(event.detail);
    this.removedDetailsRow(deletePKs, event);
    this.grid.gridApi.redrawRows();
  }

  deleteRow(event: any) {

    if (event[0].row.newRow) {
      this.grid.gridApi.applyTransaction({ remove: [event[0].row] });
    }
    else if (event[0].row?.newRow === undefined) {
      const applicationSchemePk = event[0].row?.applicationSchemePk;
      if (applicationSchemePk) {
        const deleteStructure: SaveStructure[] = [{
          transactionType: TransactionType.delete,
          row: { applicationSchemePk }
        }];
        this.gapLogicApi.savePWC(deleteStructure).pipe(take(1)).subscribe(() => {});
      }
      if (this.grid.gridApi.getDisplayedRowCount() === 1) {
        this.refreshSelectedValuesTimeout();
        this.grid.gridApi.redrawRows();
      }
    }
  }

  transformDataPWC(data: any, isInverseModeling: boolean) {
    data?.map((row: any) => {
      row.tillage = row.tillage
        ? 'Yes'
        : row.tillage != undefined
          ? 'No'
          : null;
      if (this.isPwcV2 && row.applicationOccurToYear === Constants.PWC2_LAST_VALUE) {
        row.applicationOccurToYear = 'last';
      }
      row.geographies = [];
      if (row?.applicationSchemeXGeography)
        row?.applicationSchemeXGeography.map((geography: any) => {
          const geo = this.geographies.find(
            (x: Catalog) => x.key == geography.geographyPk
          );
          if (geo) {
            row.geographies.push(geo);
          }
        });
      if (!isInverseModeling) {
        if (row.aplicationSchemeXApplication)
          row?.applicationSchemeXActiveIngredientRate.map((rate: any) => {
            let application = row?.applicationSchemeXApplication.find(
              (a: any) =>
              (a.application_scheme_x_application_pk =
                rate.application_scheme_x_application_pk)
            );
            if (application) {
              application[`rate${rate.unitOfMeasure}${rate.moleculePk}`] =
                rate.rate;
            }
          });
        row.children = row.applicationSchemeXApplication;
        if (row.children) {
          row.children.forEach((child: any) => {
            child.specifyYears = row.specifyYears;
            if (!row.dateType && child.dateType) {
              row.dateType = child.dateType;
            } else if (row.dateType && !child.dateType) {
              child.dateType = row.dateType;
            }
          });
        }
      }
    });

    this.rowData = data;
  }

  onCalendarSelectionChanged(event: any): void {
    event.params.data[event.field] = event.value;
    event.row[event.field] = event.value;
  }

  removedDetailsRow(pks: number[], row: any) {
    pks.map((x: number) => {
      this.gapLogicApi
        .DeleteDetailsPWC(x)
        .pipe(take(1))
        .subscribe({
          next: () => {
            this.grid.afterSaveSuccess();
            this.EEAGAPMenuLogicService.setSuccess(true);
            this.refreshSelectedValuesTimeout();
            this.grid.gridApi.redrawRows([x]);
          },
          error: (err: any) => {
            console.warn(err);
            this.EEAGAPMenuLogicService.setSuccess(false);
          },
        });
    });
  }

  getApplicationDetails(
    applicationSchemePk: number
  ): ApplicationSchemeXApplication[] {
    let app: ApplicationSchemeXApplication[] = [];
    this.gapLogicSWService
      .getPwcApplicationSchemeXApplicationPk(applicationSchemePk)
      .then((appSchemeXApp: ApplicationSchemeXApplication[]) => {
        app = appSchemeXApp;
      });
    return app;
  }

  async getApplicationSchemesByProjectAndCompartment(
    projectPk: number,
    compartmentPk: number
  ) {
    let children: ApplicationSchemeXApplication[] = [];

    if (projectPk != 0) {
      this.isloading = true;
      await firstValueFrom(
        this.gapLogicApi
          .getApplicationSchemesByProjectAndCompartmentPWC(
            projectPk,
            compartmentPk
          )
          .pipe(take(1))
      ).then((applicationSchemes) => {
        if (!this.selectedProject) return;
        this.gapLogicSWService
          .addActiveIngredientsRatesToGridPWC(
            applicationSchemes,
            this.detailsColumnDef,
            false,
            this.selectedProject,
            this.isProjectOwnershipValid,
            this.compartment
          )
          .then(() => {
            if (applicationSchemes != undefined)
              this.getKocRangeForApplicationScheme(applicationSchemes);
            this.rowData = this.gapLogicSWService.rowPWC;

            this.columnsDef =
              this.activeColdef.getPWCColumnsDefinition(
                this,
                this.isProjectOwnershipValid,
                this.selectedProject
              );
            if (!this.isPwcV2) this.setApplicationDateHeader();
            this.refreshSelectedValuesTimeout();
            this.show = false;
            setTimeout(() => { this.grid?.gridApi?.redrawRows(); }, 0);
          });
      });
    }
  }

  newRowAdded(newItems: any[]) {
    const itemsToProcess = Array.isArray(newItems) ? newItems : [newItems];
    itemsToProcess.forEach((item) => {
      if (!item.isDuplicate) {
        this.grid.enableControls(false);
      }
      if (this.isPwcV2 && !item.isDuplicate) {
        item.applicationOccurEveryYears = 1;
        item.applicationOccurFromYear = 1;
        item.applicationOccurToYear = 'last';
      }
    });
    this.grid.setLastRowSelected('useInProject');
    this.refreshSelectedValues();
  }
  public getKocRangeForApplicationScheme(row: any): void {
    if (row) {
      row?.forEach((row: any) => {
        if (row.kocRange) {
          this.pwcLogicScenarios.addOrUpdateKocRangeByScheme(
            row.applicationSchemePk,
            row.kocRange
          );
        }
      });
    }
  }
  public onBlurInputText({ row }: { row: any }): void {
    this.gapApplicationSchemeLogicService.checkIfApplicationSchemeIsValid(
      this,
      row.name
    );
  }

  public enableControls(enable: boolean): void {
    this.isValid.emit(enable);
    this.grid.useAddAction = enable;
  }

  public onClickButtonEvent(event: any): void {
    if (event.field == Constants.PWC_SHOW_COMPONENT_BUTTONS.SCENARIOS) {
      this.scenariosLogicService.currentRowId.set(event.rowNode.id);
      this.scenariosLogicService.visible.set(true);
      this.selectedRow = event.data;
      this.refreshSelectedValuesTimeout();
    }
  }

  public onSelectScenarios(
    selectedScenariosByRow: SelectedScenariosByRow
  ): void {
    if (!this.grid) return;
    const { rowId, selectedScenariosIds } = selectedScenariosByRow;
    const rowNode = this.grid.gridApi.getRowNode(rowId);
    const { id } = rowNode;
    const kocRange = this.pwcLogicScenarios.GetRangeKoc;
    rowNode.data.kocRange = kocRange;
    rowNode.data.cropXRegionPks = selectedScenariosIds;
    this.grid.CreateTransaction(id, id, undefined, rowNode.data);
  }

  getDatasetByProjectPk(projectPk: number) {
    this.dataSetApiService
      .getAllDatasetByProjectPk(projectPk)
      .pipe(take(1))
      .subscribe({
        next: (data) => {
          if (data) {
            const active = [
              ...new Map(
                this.selectedProject?.projectXCompoundXModel?.map((item) => [
                  item.MoleculePk,
                  item,
                ])
              ).values(),
            ];
            if (active.length > 0) {
              const filteredData = data.find(
                (dataset: any) => dataset.moleculePk === active[0]?.MoleculePk
              );
              if (filteredData) {
                this.pwcLogicService
                  .getEndpoints(filteredData.dataSetPk)
                  .then();
              }
            }
          }
        },
        error: (err) => {
          console.error('Error fetching datasets:', err);
        },
      });
  }

  private setApplicationDateHeader(row?: any): void {
    const childrens = this.detailsColumnDef?.flatMap(
      (node: { children: any }) => node.children
    );
    const appDate = childrens?.find((x: any) => x.field === 'application_date') as any;

    if (!appDate) return;

    const childRows = Array.isArray(row?.children) ? row.children : [];
    const childDateType = childRows.find((child: any) => child?.dateType)?.dateType;
    const rowDateType = row?.dateType || childDateType;
    const specifyYears = !!(row?.specifyYears || childRows.some((child: any) => !!child?.specifyYears));
    const isYearMode = specifyYears && rowDateType === Constants.DATE_TYPE_VALUES.RELATIVE;

    appDate.headerName = isYearMode
      ? 'Year'
      : Constants.PWCControlsValidations.ApplicationDate;

    this.grid?.detailGridApi?.refreshHeader?.();
  }
}
